import { CommercialIndustries } from "../../features/api-interfaces";
import { DivisionDict } from "../default-constants";

//各種ラベル
export const LABELS = {
  REGISTER_TITLE: "業態変換登録",
  START_DATE: "適用開始日",
  RULE_NO: "ルールNo",
  BEFORE_CONVERSION: "変換元業態名",
  AFTER_CONVERSION: "変換後業態コード",
  COMMENT: "コメント",
  LATEST_COMMENT: "最終コメント",
  SHOW_INDUSTRY_CONVERSIONS_INFO: "商用反映済情報",
  INDUSTRY_CONVERSIONS_INFO: "商用反映済情報",
  LAST_UPDATER: "最終更新者:",
  LAST_UPDATING_TIME: "最終更新日時:",
  LAST_AUTHORIZER: "最終承認者:",
  LAST_APPROVAL_DATE: "最終承認日:",
} as const;

// 変換後業態コード取得結果変換
export const getIndustryConversionsItems = (
  industries: CommercialIndustries[] | undefined
): DivisionDict[] => {
  if (industries !== undefined) {
    return industries.map((industries) => ({
      label: industries.industryCode + ":" + industries.industryName,
      value: industries.industryCode,
    }));
  }
  return [];
};
